import { Get, Post } from '../helpers';

export function GetProjectAlertEmails({ channel }: { channel: number }): Promise<string[]> {
  return Get({ url: `/v3/admin/auth/project-alert-emails/${channel}` });
}

export function UpdateProjectAlertEmails({
  channel,
  emails,
}: {
  channel: number;
  emails: string[];
}): Promise<string[]> {
  return Post({ url: `/v3/admin/auth/project-alert-emails/${channel}`, body: { emails } });
}
